<template>
	<el-switch
	  v-model="sValue"
	  active-color="#13ce66"
    @change="change"
  >
	</el-switch>
</template>
<script>
	export default {
		props: {
      value: {
        type: Boolean,
        default: false
      },
      scope: {
        type: Object,
        default: ()=>{
          return {}
        }
      }
		},
    data() {
      return {
        sValue: this.value
      }
    },
		methods: {
			change(val) {
          this.$emit('customBindClick', val,this.scope)
			}
		}
	}
</script>
<style lang="scss" scoped>
	.button {
    font-size: 14px;
		color: #08f;
    text-decoration: underline;
    cursor: pointer;
    margin-right: 10px;
	}
</style>